import { Operator } from './operator'
import { AdminPermEnum } from './admin-perm-enum'
import { PermEnum } from './perm-enum'

export interface MeRermInterface {
  /**
   * 本人信息
   */
  user?: Operator
  /**
   * 大后台权限列表
   */
  adminBackgroundPerms?: AdminPermEnum[]
  /**
   * 学校后台权限列表
   */
  schoolBackgroundPerms?: PermEnum[]
  passwordChangeNeeded?: boolean
}

export class MeRerm implements MeRermInterface {
  /**
   * 本人信息
   */
  user?: Operator
  /**
   * 大后台权限列表
   */
  adminBackgroundPerms?: AdminPermEnum[]
  /**
   * 学校后台权限列表
   */
  schoolBackgroundPerms?: PermEnum[]
  passwordChangeNeeded?: boolean

  constructor(props: MeRermInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      user: _user,
      adminBackgroundPerms: _adminBackgroundPerms,
      schoolBackgroundPerms: _schoolBackgroundPerms,
      passwordChangeNeeded: _passwordChangeNeeded,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.user = _user ? new Operator(_user) : _user
    this.adminBackgroundPerms = _adminBackgroundPerms
    this.schoolBackgroundPerms = _schoolBackgroundPerms
    this.passwordChangeNeeded = _passwordChangeNeeded
  }
}
